import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { DNA_STEPS } from "../../data/content";
import { reveal } from "../../lib/motion";

export const DnaTimeline = () => {
  const [active, setActive] = useState(0);
  const step = DNA_STEPS[active];

  return (
    <section
      data-testid="dna-section"
      className="grain-overlay bg-cream py-16 md:py-24 lg:py-32"
    >
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <motion.p
          {...reveal()}
          className="text-center text-xs font-semibold uppercase tracking-[0.3em] text-gold"
        >
          O DNA do AURA
        </motion.p>
        <motion.h2
          {...reveal(0.1)}
          className="mt-4 text-center font-serif text-3xl text-ink sm:text-4xl lg:text-5xl"
        >
          A jornada da Mulher AURA
        </motion.h2>
        <motion.p
          {...reveal(0.2)}
          className="mx-auto mt-4 max-w-xl text-center text-base text-mutedink sm:text-lg"
        >
          Seis movimentos que transformam uma vida inteira. Toque em cada etapa.
        </motion.p>

        {/* Desktop: nós sobre a hairline */}
        <motion.div {...reveal(0.3)} className="relative mt-20 hidden md:block">
          <div className="gold-hairline absolute left-0 right-0 top-6" />
          <div className="relative flex justify-between">
            {DNA_STEPS.map((s, i) => (
              <button
                key={s.title}
                data-testid={`dna-step-${i + 1}`}
                onClick={() => setActive(i)}
                className="group flex w-32 flex-col items-center gap-4"
              >
                <span
                  className={`flex h-12 w-12 items-center justify-center rounded-full border font-serif text-lg transition-all duration-300 ${
                    active === i
                      ? "scale-110 border-teal bg-teal text-white shadow-[0_0_30px_rgba(27,139,139,0.45)]"
                      : "border-gold-border bg-white text-gold group-hover:border-teal group-hover:text-teal"
                  }`}
                >
                  {i + 1}
                </span>
                <span
                  className={`text-[10px] font-semibold uppercase tracking-[0.2em] transition-colors duration-300 ${
                    active === i ? "text-teal" : "text-mutedink"
                  }`}
                >
                  {s.title}
                </span>
              </button>
            ))}
          </div>
        </motion.div>

        {/* Mobile: pills com scroll horizontal */}
        <div className="-mx-5 mt-12 flex gap-3 overflow-x-auto px-5 pb-2 md:hidden">
          {DNA_STEPS.map((s, i) => (
            <button
              key={s.title}
              data-testid={`dna-step-mobile-${i + 1}`}
              onClick={() => setActive(i)}
              className={`whitespace-nowrap rounded-full border px-5 py-2.5 text-[10px] font-semibold uppercase tracking-[0.2em] transition-colors duration-300 ${
                active === i
                  ? "border-teal bg-teal text-white"
                  : "border-gold-border bg-white text-mutedink"
              }`}
            >
              {s.title}
            </button>
          ))}
        </div>

        <div data-testid="dna-step-detail" className="mx-auto mt-14 max-w-3xl text-center">
          <AnimatePresence mode="wait">
            <motion.div
              key={active}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            >
              <h3 className="font-serif text-3xl italic text-teal sm:text-4xl">
                {step.title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-mutedink sm:text-lg">
                {step.description}
              </p>
            </motion.div>
          </AnimatePresence>
        </div>

        <motion.p
          {...reveal()}
          className="mx-auto mt-20 max-w-2xl text-center font-serif text-xl italic text-ink/80 sm:text-2xl"
        >
          "Quando tudo em você se conecta, a vida começa a ter outra presença."
        </motion.p>
      </div>
    </section>
  );
};
